
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatReturnFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VatReturn"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"submissionDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periodKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returnDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vatAuthority"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCountry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeAlpha2"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"box1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box6"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box7"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box8"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"box9"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox6"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox7"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox8"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentBox9"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox6"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox7"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox8"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adjustmentReasonBox9"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processingDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chargeRefNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formBundleNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentIndicator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calculationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finalised"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":715}};
    doc.loc.source = {"body":"fragment VatReturnFragment on VatReturn {\n  id\n  concurrencyVersion\n  uuid\n  submissionDate\n  periodKey\n  returnDate\n  vatAuthority {\n    id\n    concurrencyVersion\n    description\n    registration\n    country {\n      isoCountry {\n        codeAlpha2\n      }\n    }\n  }\n  box1\n  box2\n  box3\n  box4\n  box5\n  box6\n  box7\n  box8\n  box9\n  adjustmentBox1\n  adjustmentBox2\n  adjustmentBox4\n  adjustmentBox6\n  adjustmentBox7\n  adjustmentBox8\n  adjustmentBox9\n  adjustmentReasonBox1\n  adjustmentReasonBox2\n  adjustmentReasonBox4\n  adjustmentReasonBox6\n  adjustmentReasonBox7\n  adjustmentReasonBox8\n  adjustmentReasonBox9\n  processingDate\n  chargeRefNumber\n  formBundleNumber\n  paymentIndicator\n  calculationDate\n  finalised\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["VatReturnFragment"] = oneQuery(doc, "VatReturnFragment");
        
